<template>
  <el-row >
    <div v-if="liad_show">
      <load></load>
    </div>
    <el-col :span="16" :offset="4">
      <el-row style="text-align: center;">
        <h2>{{list.name}}</h2>
      </el-row>
      <el-card class="box-card" v-for="(item,index) in list.content" :key="index" style="margin-top: 1.25rem;">
        <div slot="header" class="clearfix">
          <span><span style="margin-right: 0.3125rem;font-size: 0.9375rem;">{{index+1}}.</span>{{item.name}}</span>
          <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
        </div>
        <el-row v-if="item.type=='input'">
          <el-input disabled :value="input"></el-input>
        </el-row>
        <el-row v-else v-for="(items,indexs) in item.choice" :key="indexs" class="text item" >
          <el-radio v-if="item.type=='radio'" disabled  v-model="item.name" :label="items.num">{{items.name}}</el-radio>
          <el-checkbox v-else  :label="indexs" disabled style="width: 100%;" @change="change(index, indexs)">
                  {{items.name}}
          </el-checkbox>
        </el-row>
      </el-card>
      <el-row v-if="list.c_id!='0'" style="background-color: white;height: 6.25rem; display: flex; justify-content: center;align-items: center; margin-top: 3.125rem;">
        <el-button type="primary" @click="preservation()">组成问卷</el-button>
      </el-row>
    </el-col>
  </el-row>
</template>

<script>
  import load from "../../../../components/load.vue"
  export default {
    data() {
      return {
        num:this.$route.query.num,
        list:{},
        input:'',
        liad_show:false,
      }
    },
    components: {
      load:load
    },
    mounted () {
       this.get_info();
       },
    methods: {
      preservation(){
        let _this=this
        _this.liad_show=true
        let data={
          type:'status',
          num:_this.num,
          status:1
        }
        _this.axios.post("/v2/c_investigate/investigate_up",{data:data}).then(function (res) {
          if(res.data.code=='1'){
            _this.$message.success(res.data.msg)
            _this.liad_show=false
            _this.$router.push({path:'/quest_release',query:{num:_this.num}})
          }else{
            _this.$message.error(res.data.msg)
            _this.liad_show=false
          }
        })
      },
      get_info(){
        let _this=this
        _this.liad_show=true
        _this.axios.get("/v2/c_investigate/investigate_info",{params: {
          num:_this.num,
        }}).then(function (res) {
          if (res.status == "200") {
            if(res.data.code=='1'){
              _this.list=res.data.data
              _this.liad_show=false
            }else{
              _this.$message.error(res.data.msg)
              _this.liad_show=false
            }
          } else {
            _this.liad_show=false
            _this.$message.error("服务器内部错误")
          }
        })
        // _this.list={
        //   name:'调查问卷',
        //   list:[{
        //     name:'试题1',
        //     choice:[{name:'选项1',num:'0'},{name:'选项2',num:'1'},{name:'选项3',num:'2'},],
        //     type:'radio'
        //     },
        //     {
        //       name:'试题2',
        //       choice:[{name:'选项1',num:'0'},{name:'选项2',num:'1'},{name:'选项3',num:'2'},],
        //       type:'checkbox'
        //     },
        //     {
        //       name:'试题3',
        //       type:'input'
        //     },
        //     {
        //       name:'试题2',
        //       choice:[{name:'选项1',num:'0'},{name:'选项2',num:'1'},{name:'选项3',num:'2'},],
        //       type:'checkbox'
        //     },
        //     {
        //       name:'试题3',
        //       type:'input'
        //     },
        //   ],
        // }
        // for(let i=0;i<_this.list.list.length;i++){
        //   if(type=='checkbox'){
        //     _this.list.list[i]['user_choice']=[]
        //   }else{
        //     _this.list.list[i]['user_choice']=''
        //   }

        // }
      }
    }

  }
</script>

<style scoped>
   .text {
      font-size: 14px;
    }

    .item {
      margin-bottom: 18px;
    }

    .clearfix:before,
    .clearfix:after {
      display: table;
      content: "";
    }
    .clearfix:after {
      clear: both
    }

    .box-card {

    }
</style>



// WEBPACK FOOTER //
// src/view/company/questionnaire/quest_list/preview.vue